export type StoryProgressCallbacks = {
  getIsPaused: () => boolean;
  getCurrentProgress: () => number;
  setProgress: (value: number) => void;
  onComplete: () => void;
};

export class CarouselProgressEngine {
  private animationFrameId: number | null = null;
  private startedAt = 0;

  constructor(
    private readonly durationMs: number,
    private readonly callbacks: StoryProgressCallbacks,
  ) {}

  start(): void {
    this.stop();
    this.callbacks.setProgress(0);
    this.startedAt = performance.now();
    this.animationFrameId = requestAnimationFrame(this.tick);
  }

  resumeFromCurrent(): void {
    this.stop();
    this.startedAt = performance.now() - (this.callbacks.getCurrentProgress() / 100) * this.durationMs;
    this.animationFrameId = requestAnimationFrame(this.tick);
  }

  stop(): void {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  destroy(): void {
    this.stop();
  }

  private readonly tick = (timestamp: number): void => {
    if (this.callbacks.getIsPaused()) {
      this.startedAt = timestamp - (this.callbacks.getCurrentProgress() / 100) * this.durationMs;
      this.animationFrameId = requestAnimationFrame(this.tick);
      return;
    }
    const elapsedMs = timestamp - this.startedAt;
    const nextProgress = Math.min((elapsedMs / this.durationMs) * 100, 100);
    this.callbacks.setProgress(nextProgress);
    if (nextProgress >= 100) {
      this.callbacks.onComplete();
      return;
    }
    this.animationFrameId = requestAnimationFrame(this.tick);
  };
}
